import { render, staticRenderFns } from "./FixAppSubscription.vue?vue&type=template&id=2daa67a1&scoped=true&"
import script from "./FixAppSubscription.vue?vue&type=script&lang=js&"
export * from "./FixAppSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa67a1",
  null
  
)

export default component.exports